<template>
    <v-row class="PrepareSignatureTopbar" align="center" no-gutters>
      <v-col class="pl-5 py-4">
        <AppTooltip>
          <template #activator="{ props }">
            <h3 class="PrepareSignatureTopbar-envelopeName" v-bind="props" data-locator="file-name">
              {{ envelopeName }}
            </h3>
          </template>
          <span>{{ envelopeName }}</span>
        </AppTooltip>
      </v-col>
      <v-col v-if="pagesCount > 0" class="text-right pr-5 py-1" data-locator="page-selection">
        <span class="text--medium">{{ $t('common.page') }}</span>
        <input
          v-model="newPage"
          type="number"
          class="PrepareSignatureTopbar-pageInput"
          :class="{ 'input-error': newPage < 1 || newPage > pagesCount }"
          data-locator="page-number-input"
          :min="1"
          :max="pagesCount"
          v-on:input="newPage = $event.target.value"
          v-on:keydown.enter="scrollToPageNumber"
          v-on:change="onPageNumberChange"
        >
        <span class="text--medium" data-locator="pages-count">{{ `/ ${pagesCount}` }}</span>
      </v-col>
    </v-row>
</template>

<script>
import { debounce } from 'lodash-es'
import { defineComponent } from 'vue'

import AppTooltip from '@/common/AppTooltip.vue'

export default defineComponent({
  name: 'PrepareSignatureTopbar',
  components: {
    AppTooltip,
  },
  emits: ['scroll-to'],
  props: {
    envelopeName: {
      type: String,
      default: '',
    },
    pagesCount: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: [Number, String],
      required: true,
    },
  },
  data () {
    return {
      newPage: this.currentPage,
    }
  },
  watch: {
    currentPage: function (newValue) {
      this.newPage = newValue
    },
  },
  created () {
    this.onPageNumberChange = debounce(this.onPageNumberChange, 800)
  },
  methods: {
    scrollToPageNumber () {
      if (this.newPage >= 1 && this.newPage <= this.pagesCount) {
        this.$emit('scroll-to', this.newPage)
      }
    },
    onPageNumberChange () {
      this.scrollToPageNumber()
    },
  },
})
</script>

<style scoped lang="scss">
.PrepareSignatureTopbar {
  background-color: rgb(var(--v-theme-grey-50));
  border: 1px solid #DEE2E6;
}
.PrepareSignatureTopbar-envelopeName {
  max-width: 1000px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.PrepareSignatureTopbar-pageInput {
  background: white;
  border: 1px solid rgb(var(--v-theme-tertiary-darken-1));
  border-radius: 3px;
  padding: 3px 10px;
  margin: 0 4px;
  max-width: 80px;
  outline:none;

  &.input-error {
    border: 1px solid rgb(var(--v-theme-error-darken-1));
  }
}
</style>
